import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import ReactDOMServer from "react-dom/server";
import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { adaptPie } from "@Local/Dashboard/dashboard.util";
// 從低到高
const EXPIRE_LEVEL_CONFIG = [
	{ color: "#BE123C", message: "高續約風險族群" },
	{ color: "#FB7185", message: "需關注續約狀態" },
	{ color: "#5B0F74", message: "穩定會籍族群\n短期內續約風險低" },
];
const MessagesLabel = ({ name, value, percent, message }) => {
	return (
		<React.Fragment>
			<strong>{name}</strong>
			<br />
			{`${value} 人（${percent}%）`}
			<br />
			<br />
			<span>{message}</span>
		</React.Fragment>
	);
};
/********* 會籍到期時間 *********/
const MembershipExpireTime = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const { sourceData = { xAxis: ["0-1個月", "2~3個月", "3個月以上"], data: [12, 20, 68] } } = props;
	const { data = [], centerValueText = "" } = adaptPie(sourceData, EXPIRE_LEVEL_CONFIG);
	const isLoading = data.length === 0;
	const title = "會籍到期時間";
	const subTitle = "追蹤續約可能指標";
	const option = {
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},
		legend: {
			left: "center",
			bottom: 14,
			textStyle: {
				fontSize: 14,
				fontWeight: 600,
			},
		},
		series: [
			{
				type: "pie",
				radius: ["50%", "65%"],
				center: ["50%", "55%"],
				avoidLabelOverlap: false,
				padAngle: 3,
				itemStyle: {
					borderRadius: 6,
				},
				label: { show: false },
				labelLine: { show: false },
				data: data,
			},
		],
		tooltip: {
			trigger: "item",
			formatter: params => {
				const { name, value, percent, marker, data } = params;
				const html = ReactDOMServer.renderToStaticMarkup(
					<MessagesLabel
						name={name}
						value={value}
						percent={Math.round(percent)}
						message={data.message} // ← 直接拿
					/>,
				);
				return marker + html;
			},
		},
		graphic: [
			{
				type: "text",
				left: "center",
				top: "43%",
				style: {
					text: "續約風險",
					fill: "#94A3B8",
					fontSize: 28,
					textAlign: "center",
				},
			},
			{
				type: "text",
				right: "50%",
				top: "52%",
				style: {
					text: centerValueText,
					fill: "#E11D48",
					fontSize: 60,
					fontWeight: 700,
					textAlign: "center",
				},
			},
			{
				type: "text",
				left: "50%",
				top: "52%",
				style: {
					text: "%",
					fill: "#E11D48",
					fontSize: 60,
					fontWeight: 700,
					textAlign: "center",
				},
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default MembershipExpireTime;
